import React, { useState } from "react"
import { Formik, Form, Field } from "formik"
import { useNavigate } from "react-router-dom"
import Switch from "components/Shared/Switch"
import { Button } from "reactstrap"
import { useDispatch } from "react-redux"
import { updateItem } from "store/actions/itemsAction"
import { showAlert } from "store/reducers/alertReducer"
import Select from "react-select"
import { allOption } from "components/Common/constants"

const AdvanceSetting = ({
  formValues,
  allCategories,
  fields,
  setFields,
  setAdvanceSettingValues,
  branchsList,
  categoryId,
  itemId,
  isLoading,
  t,
  language,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleAddButtonClick = () => {
    setFields([...fields, { branch: "", price: "" }])
  }

  const handleChange = (index, fieldName, value) => {
    const newFields = [...fields]
    newFields[index][fieldName] = value
    setFields(newFields)
  }

  const handleRemoveButtonClick = index => {
    const newFields = [...fields]
    newFields.splice(index, 1)
    setFields(newFields)
  }

  const handleSubmit = values => {
    setAdvanceSettingValues(values)

    const {
      nameAr,
      nameEn,
      descriptionAr,
      descriptionEn,
      displayOrder,
      imageType,
      imageUrl,
      imageFile,
      itemPrice,
      originalPrice,
      caloriesForDisplay,
      personCountPerServing,
      caloriesForCalculations,
      enabled,
      disablePickup,
      disableDelivery,
    } = values

    const {
      category,
      isDiscountAllowed,
      isCombo,
      isFeatured,
      specialPrice,
      disabledBranches,
      outOfStockForBranches,
    } = values

    let data = new FormData()
    data.append("name", nameEn)
    data.append("nameAr", nameAr)
    data.append("description", descriptionEn)
    data.append("descriptionAr", descriptionAr)
    data.append("displayOrder", displayOrder)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    data.append("status", enabled ? 1 : 0)
    data.append("image", imageFile)
    data.append("personCountPerServing", personCountPerServing)
    data.append("disableForPickup", disablePickup)
    // data.append("disableForDelivery", disableDelivery)
    data.append("price", itemPrice)
    data.append("originalPrice", originalPrice)
    data.append("calories", caloriesForCalculations)
    data.append("calorieCount", caloriesForCalculations)
    if (category) {
      data.append("categoryId", category)
    } else {
      data.append("categoryId", categoryId)
    }
    data.append("id", itemId)
    // data.append("isFeatured", isFeatured)
    // data.append("isDiscountAllowed", isDiscountAllowed)
    // data.append("isCombo", isCombo)
    data.append("isCustomizable", specialPrice)

    const outOfStockValues = outOfStockForBranches?.map(
      location => location.value
    )

    const disabledBranchesValue = disabledBranches?.map(
      location => location.value
    )
    if (specialPrice) {
      fields.forEach((field, index) => {
        data.append(`prices[${index}][branch]`, field.branch)
        data.append(`prices[${index}][price]`, field.price)
      })
    }
    if (disabledBranchesValue.length === 0) {
      data.append(`disabledBranches[]`, [])
    } else {
      disabledBranchesValue.forEach((element, index) => {
        data.append(`disabledBranches[${index}]`, element)
      })
    }

    if (outOfStockValues.length === 0) {
      data.append(`outOfStockForBranches[]`, [])
    } else {
      outOfStockValues.forEach((element, index) => {
        data.append(`outOfStockForBranches[${index}]`, element)
      })
    }

    dispatch(updateItem(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const [isAllSelected, setIsAllSelected] = useState(false)
  const [isAllSelected2, setIsAllSelected2] = useState(false) // FOR OUT OF STOCK FIELD

  const branchListOptions = branchsList?.map(item => ({
    label: language === "sa" ? item.nameAr : item.name,
    value: item._id,
  }))

  const options = isAllSelected
    ? branchListOptions
    : [allOption, ...branchListOptions]

  const options2 = isAllSelected2
    ? branchListOptions
    : [allOption, ...branchListOptions]

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={formValues}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form>
            <div className="row">
              <div className="col-lg-4 mt-0">
                <div className="">
                  <label htmlFor="category">{t("Category")}</label>
                  <Field
                    as="select"
                    name="category"
                    id="category"
                    className={`form-control ${
                      errors.category && touched.category ? "is-invalid" : ""
                    }`}
                  >
                    <option hidden>{t("Select Category")}</option>

                    {allCategories &&
                      allCategories?.map(option => (
                        <option key={option._id} value={option._id}>
                          {language === "sa" ? option.nameAr : option.name}
                        </option>
                      ))}
                  </Field>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="">
                  <label htmlFor="disabledBranches">
                    {t("Disable For Branches")}
                  </label>
                  <Select
                    value={values.disabledBranches}
                    isMulti={true}
                    onChange={item => {
                      if (item?.find(option => option.value === "*")) {
                        setFieldValue("disabledBranches", branchListOptions)
                        setIsAllSelected(true)
                      } else {
                        setFieldValue("disabledBranches", item)
                        setIsAllSelected(
                          item.length === branchListOptions.length
                        )
                      }
                    }}
                    options={options}
                    className="select2-selection"
                    closeMenuOnSelect={false}
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="">
                  <label
                    htmlFor="outOfStockForBranches"
                    style={{ marginBottom: 7 }}
                  >
                    {t("Out Of Stock For Branches")}
                  </label>
                  <Select
                    value={values.outOfStockForBranches}
                    isMulti={true}
                    onChange={item => {
                      if (item?.find(option => option.value === "*")) {
                        setFieldValue(
                          "outOfStockForBranches",
                          branchListOptions
                        )
                        setIsAllSelected2(true)
                      } else {
                        setFieldValue("outOfStockForBranches", item)
                        setIsAllSelected2(
                          item.length === branchListOptions.length
                        )
                      }
                    }}
                    options={options2}
                    className="select2-selection"
                    closeMenuOnSelect={false}
                  />
                </div>
              </div>

              {/* <div className="col-lg-3">
                <div className="form_field d-flex align-items-center">
                  <label htmlFor="isDiscountAllowed" className="mx-2 pt-2">
                    Allow Discounts
                  </label>
                  <Switch
                    isChecked={values.isDiscountAllowed}
                    onClickHandler={() => {
                      setFieldValue(
                        "isDiscountAllowed",
                        !values.isDiscountAllowed
                      )
                    }}
                  />
                </div>
              </div> */}
              {/* <div className="col-lg-3">
                <div className="form_field d-flex align-items-center">
                  <label htmlFor="isCombo" className="mx-2 pt-2">
                    Convert to Combo
                  </label>
                  <Switch
                    isChecked={values.isCombo}
                    onClickHandler={() => {
                      setFieldValue("isCombo", !values.isCombo)
                    }}
                  />
                </div>
              </div> */}
              {/* <div className="col-lg-3">
                <div className="form_field d-flex align-items-center">
                  <label htmlFor="isFeatured" className="mx-2 pt-2">
                    Featured Item
                  </label>
                  <Switch
                    isChecked={values.isFeatured}
                    onClickHandler={() => {
                      setFieldValue("isFeatured", !values.isFeatured)
                    }}
                  />
                </div>
              </div> */}
              <div className="col-lg-3 mt-3">
                <div className="form_field d-flex align-items-center">
                  <label htmlFor="specialPrice" className="mx-2 pt-2">
                    {t("Special Price")}
                  </label>
                  <Switch
                    isChecked={values.specialPrice}
                    onClickHandler={() => {
                      setFieldValue("specialPrice", !values.specialPrice)
                    }}
                  />
                </div>
              </div>

              {values.specialPrice &&
                fields?.map((field, index) => (
                  <div className="row align-items-end" key={index}>
                    <div className="col-lg-5">
                      <div className="form_field">
                        <label htmlFor={`branch${index}`}>{t("Branch")}</label>
                        <select
                          id={`branch${index}`}
                          value={field.branch}
                          onChange={e =>
                            handleChange(index, "branch", e.target.value)
                          }
                        >
                          <option hidden>{t("Select Branch")}</option>
                          {branchsList &&
                            branchsList?.map(option => (
                              <option key={option._id} value={option._id}>
                                {language === "sa"
                                  ? option.nameAr
                                  : option.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="form_field">
                        <label htmlFor={`price${index}`}>
                          {t("Unit Price")}
                        </label>
                        <input
                          type="text"
                          id={`price${index}`}
                          value={field.price}
                          onChange={e =>
                            handleChange(index, "price", e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form_field">
                        <Button
                          color="danger"
                          onClick={() => handleRemoveButtonClick(index)}
                        >
                          {t("Remove")}
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}

              {values.specialPrice && (
                <div className="col-lg-12 mt-2">
                  <div className="form_field">
                    <Button
                      color="primary"
                      type="button"
                      onClick={handleAddButtonClick}
                    >
                      {t("Add Branch And Price")}
                    </Button>
                  </div>
                </div>
              )}

              <div className="col-12 d-flex justify-content-end my-5">
                <Button
                  type="button"
                  className="mx-2"
                  color="secondary"
                  onClick={() => navigate(-1)}
                >
                  {t("Cancel")}
                </Button>
                <Button color="success" type="submit" disabled={isLoading}>
                  {t("Save")}
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default AdvanceSetting
